module.exports = __webpack_public_path__ + "img/gold_framed_symbols.36379f2d.png";